// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3TB6O","author":"Table_author__3MQZq","authorImage":"Table_authorImage__2Roy9","unreadRow":"Table_unreadRow__3nyh9"};